
import { Component, Vue, Prop, Watch, Emit, Ref, Mixins } from 'vue-property-decorator'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import MultiContent from './content/multiContent.vue'
import { Observer } from 'mobx-vue'
import { MixinsHomeClick } from '@xt/client/mixins/home'

@Observer
@Component({
  components: {
    NewSwiper,
    MultiContent
  }
})
export default class SpecialCourse extends Mixins(MixinsHomeClick) {
  get dataSource() {
    return this.$store.$homeV2.dataSource?.specialTopicCourse
  }

  handleClickMore() {
    if (this.dataSource?.more) {
      this.onClickEvent(this.dataSource.more)
      return
    }

    window.open('/product/list?typeCurrent=2&directionCurrent=0')
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
